// extracted by mini-css-extract-plugin
export default {"wrapper":"MenuInfo__wrapper--2l_5w","file":"MenuInfo__file--1Pi8-"};